import { ref } from 'vue';

// Which home grid the user sees (ADR-0049): the VP-style grid, or the classic
// one kept as the way back until the new grid has run a full period.
export type GridView = 'new' | 'classic';

const STORAGE_KEY = 'tc:grid-view:v1';

function load(): GridView {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'classic' ? 'classic' : 'new';
  } catch {
    return 'new';
  }
}

function save(view: GridView): void {
  try {
    localStorage.setItem(STORAGE_KEY, view);
  } catch {
    // storage unavailable (private browsing, quota): the choice lasts this page only
  }
}

export function useGridView() {
  const view = ref<GridView>(load());
  function setView(next: GridView): void {
    view.value = next;
    save(next);
  }
  return { view, setView };
}
